export function formatList(intl, list) {
    return intl.formatList(list);
}
